export default __webpack_public_path__ + "static/media/AGC_2024_R3_QP_Class_4.56b8c694.pdf";